export const EMAIL_ACTION_MODES = {
  resetPassword: "resetPassword",
  signIn: "signIn",
  verifyEmail: "verifyEmail",
};
